module.exports = __webpack_public_path__ + "static/media/google-icon.578c4aac.svg";